import { Button, Popconfirm } from 'antd'
import { DeliveryOrderApi } from 'api/Purchase/DeliveryOrder'
import useSubmit from 'elements/Hooks/useSubmit'

import React from 'react'

export function AutoWorkFlow({ owner}) {
  const [submitting, submitFunc] = useSubmit(() => DeliveryOrderApi.autoWorkflow({ _id: owner._id }))

  return (
    <div>
      <Popconfirm
        title="Are you sure to Run the AutoWorkflow for this DO?"
        onConfirm={() => submitFunc()}
        okText="Yes"
        cancelText="No">
        <Button type="primary" loading={submitting}>
          Auto WorkFlow
        </Button>
      </Popconfirm>
    </div>
  )
}
